import EVENTS from '@/utils/Constants/Events';

export const notifyError = message => {
  DLG.EVE.emit(EVENTS.NOTIFICATION.ADD.ERROR, { message });
};

export const notifySuccess = message => {
  DLG.EVE.emit(EVENTS.NOTIFICATION.ADD.SUCCESS, { message });
};
